import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/nations/match-bg-bracket.png")